import { Action, createReducer, on } from '@ngrx/store';
import * as MessageHubActions from '../../../../../state/actions/message-hub.actions';

export interface AppHeaderState {
    //notifications: BcsNotification[];
    bcsNotifications: NotificationMessageModel;
}

export interface NotificationMessageModel {
    messages: NotificationMessageDto[],
    immediateAlertCount: number,
    interactionThresholdAlertCount: number,
    waitAlertCount: number
}

interface NotificationMessageDto {
    tenantId: number,
    messageId: number,
    isMessageRead: boolean,
    ltsAlertDto: LtsAlert
}

interface LtsAlert {
    alertType: "ImmediateAlert" | "InteractionThresholdAlert" | "WaitAlert",
    addedTime: string,
    alertDescription: string
}

const initialAppHeaderState: AppHeaderState = {
    bcsNotifications: {
        immediateAlertCount: 0,
        interactionThresholdAlertCount: 0,
        messages: [],
        waitAlertCount: 0
    }
};

const reducer = createReducer<AppHeaderState>(
    initialAppHeaderState,
    on(MessageHubActions.receivedActiveAlertsForUser, (appHeaderState, action): AppHeaderState => (
        {
            ...appHeaderState,
            bcsNotifications: action.messageData === '' ? appHeaderState.bcsNotifications : JSON.parse(action.messageData)
        }
    ))
);

export function appHeaderReducer(state: AppHeaderState | undefined, action: Action) {
    return reducer(state, action);
}
